export default {
  zoom: 19,
  mapTypeId: 'satellite',
  tilt: 0,
  fullscreenControl: true,
  rotateControl: false,
  streetViewControl: false,
  mapTypeControlOptions: {
    position: window.google.maps.ControlPosition.TOP_RIGHT
  },
  styles: [
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Map/map-config.js